import { SelectSearcher } from "_components/Abstractions/MultiSearcher/SelectSearcher";
import { useEffect, useState } from "react";
import { formatWasteExchangeContainerName } from "_helpers/wasteExchangeContainerName";

export function WasteExchangeContainerSelect({ name, wasteExchanges, saveWholeObject = true }) {
  const [items, setItems] = useState([]);
  const containerItems = (wasteExchanges ?? [])
    .filter(x => x.isContainer)
    .map(x => ({
      wasteExchangeId: x.wasteExchangeId,
      orderExchangeContainerName: formatWasteExchangeContainerName(x),
      usedContainerId: x.usedContainerId
    }));

  const onSearchChange = (searchTerm) => {
    if (!searchTerm) {
      setItems(containerItems);
      return;
    }

    const filtered = containerItems.filter(x =>
      x.orderExchangeContainerName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setItems(filtered);
  };

  useEffect(() => {
    setItems(containerItems);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wasteExchanges]);

  return (
    <SelectSearcher
      name={name}
      label="Kontener"
      items={items}
      onSearchChange={onSearchChange}
      optionsObject={{ key: "wasteExchangeId", value: "orderExchangeContainerName" }}
      placeholder="Wyszukaj kontener..."
      readonly={containerItems.length === 0}
      saveWholeObject={saveWholeObject}
    />
  );
}
